export default __webpack_public_path__ + "5652171230ad0c68128107c3c1b5096e.png";